module.exports = __webpack_public_path__ + "img/14.a6079674.jpg";